//import UserGroupDataFunc from "@/pcomponents/common/content/list/tab1/func/group_data";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";
import GetFilterUser from "./get_filter_user";
import GetOrderUser from './get_order_user';

class UserGroupDataFunc {
  static get_cardbox_group_data_arr(inData: any) {
    let opt_obj = {
      select_date: "",
      info_arr: [],
      listOpt: {},
      tab_id: "",
      now_ymdhis: DateFunc.get_date_format(new Date(), "Y-m-d h:i:s"),
      is_only_now_desk: false,
      is_order_by_desk_use: false,
      is_order_by_attend: false,
      is_order_by_core_date: false,
      is_filter_todo_complete: false,
      is_filter_desk_complete: false,
      is_filter_absent: false,
      ...inData,
    };
    let select_date = opt_obj["select_date"];
    if (strFunc.is_empty(select_date)) {
      select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let tab_id = opt_obj["tab_id"];
    let info_arr = opt_obj["info_arr"];
    let group_data_arr: any = [];//[{title:"","info_arr":[]}]
    if (tab_id == "") {
      group_data_arr.push({
        "title": "기타", "info_arr": info_arr,
      });
    } else if (tab_id == "class") {
      group_data_arr = this.get_class_group_arr(info_arr);
    } else if (tab_id == "stu_grade") {
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        let stu_grade = "기타";
        if (!strFunc.is_empty(info["a_stu_grade"])) {
          stu_grade = info["a_stu_grade"];
        }
        let group_row_idx = this.get_group_arr_idx_of_title(stu_grade, group_data_arr);
        if (group_row_idx == -1) {
          group_data_arr.push({
            "title": stu_grade,
            "info_arr": [info],
          });
        } else {
          group_data_arr[group_row_idx]["info_arr"].push(info);
        }
      }
    } else if (tab_id == "school") {
      for (let i = 0; i < info_arr.length; i++) {
        let info = info_arr[i];
        let school_name = "기타";
        if (!strFunc.is_empty(info["a_school_name"])) {
          school_name = info["a_school_name"];
        }
        let group_row_idx = this.get_group_arr_idx_of_title(school_name, group_data_arr);
        if (group_row_idx == -1) {
          group_data_arr.push({
            "title": school_name,
            "info_arr": [info],
          });
        } else {
          group_data_arr[group_row_idx]["info_arr"].push(info);
        }
      }
    } else if (tab_id == "room") {
      group_data_arr = this.get_room_group_arr({
        "info_arr": info_arr,
      });
    } else if (tab_id == "lecture") {
      group_data_arr = this.get_lecture_time_group_arr({
        "info_arr": info_arr,
        listOpt: opt_obj.listOpt,
        "select_date": select_date,
        now_ymdhis: opt_obj.now_ymdhis,
        is_only_now_desk: opt_obj.is_only_now_desk,
        is_order_by_desk_use: opt_obj.is_order_by_desk_use,
        is_order_by_attend: opt_obj.is_order_by_attend,
        is_order_by_core_date: opt_obj.is_order_by_core_date,
        is_filter_todo_complete: opt_obj.is_filter_todo_complete,
        is_filter_desk_complete: opt_obj.is_filter_desk_complete,
        is_filter_absent: opt_obj.is_filter_absent,
      });
    }

    group_data_arr = this.get_ordered_by_title_name(group_data_arr);

    return group_data_arr;
  };
  static get_class_group_arr(info_arr: any) {
    let group_arr: any = [];
    let class_group_arr: any = {};//{"class_seq":{"class_info":null,"info_arr":[]}}
    let info_arr_len = info_arr.length;
    let no_class_seq_arr = [];
    for (let i = 0; i < info_arr_len; i++) {
      let info = info_arr[i];
      if (info.class_arr && info.class_arr.length > 0) {
        let class_info = info.class_arr[0];
        if (class_info.class_info) {
          class_info = class_info.class_info;
          if (class_group_arr[class_info["a_seq"]] == undefined) {
            class_group_arr[class_info["a_seq"]] = {
              "class_info": class_info,
              "info_arr": [],
            };
          }
          class_group_arr[class_info["a_seq"]]["info_arr"].push(info);
        } else {
          no_class_seq_arr.push(info["a_seq"]);
        }
      } else {
        no_class_seq_arr.push(info["a_seq"]);
      }
    }

    for (let key in class_group_arr) {
      let class_group = class_group_arr[key];
      group_arr.push({
        "title": class_group["class_info"]["a_name"],
        "info_arr": class_group["info_arr"],
      });
    }
    if (no_class_seq_arr.length > 0) {
      let no_class_info_arr = [];
      for (let i = 0; i < info_arr_len; i++) {
        let info = info_arr[i];
        if (strFunc.str_in_array(info["a_seq"], no_class_seq_arr) != -1) {
          no_class_info_arr.push(info);
        }
      }
      group_arr.push({
        "title": "기타",
        "info_arr": no_class_info_arr,
      });
    }

    return group_arr;
  };

  static get_group_arr_idx_of_title(title: string, group_arr: []) {
    for (let i = 0; i < group_arr.length; i++) {
      if (group_arr[i]["title"] == title) {
        return i;
      }
    }
    return -1;
  }

  static get_ordered_by_title_name(group_data_arr: any) {
    let title_str_arr = [];
    for (let i = 0; i < group_data_arr.length; i++) {
      if (group_data_arr[i]["title"] != "기타") {
        title_str_arr.push(group_data_arr[i]["title"]);
      }
    }
    title_str_arr.push("기타");

    title_str_arr.sort();

    let new_group_data_arr = [];
    for (let i = 0; i < title_str_arr.length; i++) {
      for (let j = 0; j < group_data_arr.length; j++) {
        if (group_data_arr[j]["title"] == title_str_arr[i]) {
          new_group_data_arr.push(group_data_arr[j]);
        }
      }
    }
    return new_group_data_arr;
  };

  static get_room_group_arr(inData: any) {
    let opt_obj = {
      info_arr: [],
      ...inData,
    };
    let info_arr = opt_obj["info_arr"];
    let group_arr: any = [];
    let group_json: any = {};
    let group_name_arr: any = [];
    let etc_user_arr: any = [];

    //방이름 모으기
    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      let is_room_exist = false;
      if (info.lecture_arr && info.lecture_arr.length > 0) {
        for (let lec_i = 0; lec_i < info.lecture_arr.length; lec_i++) {
          let lecture_info = info.lecture_arr[lec_i];
          if (lecture_info.a_room_name) {
            is_room_exist = true;
            if (strFunc.str_in_array(lecture_info.a_room_name, group_name_arr) == -1) {
              group_name_arr.push(lecture_info.a_room_name);
            }
          }
        }
      }
      if (is_room_exist == false) {
        etc_user_arr.push(info);
      }
    }

    //방 그룹 만들기
    for (let i = 0; i < group_name_arr.length; i++) {
      let group_name = group_name_arr[i];
      group_json[group_name] = {
        "title": group_name,
        "info_arr": [],
      };
    }
    if (etc_user_arr.length > 0) {
      group_json["기타"] = {
        "title": "기타",
        "info_arr": etc_user_arr,
      };
    }

    //방별로 유저넣기
    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      if (info.lecture_arr && info.lecture_arr.length > 0) {
        for (let lec_i = 0; lec_i < info.lecture_arr.length; lec_i++) {
          let lecture_info = info.lecture_arr[lec_i];
          if (lecture_info.a_room_name) {
            group_json[lecture_info.a_room_name]["info_arr"].push(info);
          }
        }
      }
    }

    //배열로 만들기
    for (let key in group_json) {
      group_arr.push(group_json[key]);
    }

    return group_arr;
  };

  static get_lecture_time_group_arr(inData: any) {
    let opt_obj = {
      select_date: "",
      info_arr: [],
      listOpt: {},
      now_ymdhis: "",
      is_only_now_desk: false,
      is_order_by_desk_use: false,
      is_order_by_attend: false,
      is_order_by_core_date: false,
      is_filter_todo_complete: false,
      is_filter_desk_complete: false,
      is_filter_absent: false,
      ...inData,
    };
    let this_obj = this;
    let info_arr = opt_obj["info_arr"];
    let select_date = opt_obj["select_date"];
    if (strFunc.is_empty(select_date)) {
      select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let group_arr: any = [];//[{"title":"","info_arr":[],"subject":""}]
    let info_arr_len = info_arr.length;
    let now_d_json = DateFunc.get_date_json(new Date(select_date));
    let listOpt = opt_obj.listOpt;
    let s_stu_lecture_seq_arr: any = [];
    if (listOpt.s_stu_lecture_seq) {
      if (typeof listOpt.s_stu_lecture_seq == "object") {
        s_stu_lecture_seq_arr = listOpt.s_stu_lecture_seq;
      } else {
        s_stu_lecture_seq_arr = [listOpt.s_stu_lecture_seq];
      }
    }

    let lecture_time_group_arr: any = {};//{time_str:{title:"",time_str:"",info_arr:[]}}
    let filter_group_arr: any = {};
    for (let info_i = 0; info_i < info_arr_len; info_i++) {
      let info = info_arr[info_i];
      let key_str = "";
      let lecture_arr = info["lecture_arr"];

      //추가 daily_lecture_arr
      // if(info.daily_lecture_arr&&info.daily_lecture_arr.length>0){
      //   let tmp_pre_lecture_seq_arr=[];
      //   for(let lec_i=0;lec_i<lecture_arr.length;lec_i++){
      //     tmp_pre_lecture_seq_arr.push(lecture_arr[lec_i]["a_seq"]);
      //   }
      //   for(let lec_i=0;lec_i<info.daily_lecture_arr.length;lec_i++){
      //     let lecture_info=info.daily_lecture_arr[lec_i];
      //     if(strFunc.str_in_array(lecture_info["a_seq"],tmp_pre_lecture_seq_arr)==-1){
      //       lecture_arr.push(lecture_info);
      //     }
      //   }
      // }

      if (lecture_arr && lecture_arr.length > 0) {
        for (let lec_i = 0; lec_i < lecture_arr.length; lec_i++) {
          let lecture_info = lecture_arr[lec_i];
          if (s_stu_lecture_seq_arr.length > 0) {
            if (strFunc.str_in_array(lecture_info["a_seq"], s_stu_lecture_seq_arr) == -1) {
              continue;
            }
          }
          if (lecture_info["stu_union_time_arr"] && lecture_info["stu_union_time_arr"].length > 0) {
            for (let time_i = 0; time_i < lecture_info["stu_union_time_arr"].length; time_i++) {
              let union_time = lecture_info["stu_union_time_arr"][time_i];
              if (union_time["a_stu_seq"] == info["a_seq"]) {
                if (union_time["a_day_num"] == now_d_json["day"]) {
                  let is_filter_group = GetFilterUser.get_is_filter_user({
                    ...opt_obj,
                    info: info,
                    subject_name: lecture_info["a_subject"],
                    now_ymdhis: opt_obj.now_ymdhis,
                    is_only_now_desk: opt_obj.is_only_now_desk,
                    is_filter_absent: opt_obj.is_filter_absent,
                    is_filter_todo_complete: opt_obj.is_filter_todo_complete,
                  });

                  let start_time_str = strFunc.HourMinuteToTime(union_time["a_start_h"], union_time["a_start_m"]);
                  let end_time_str = strFunc.HourMinuteToTime(union_time["a_end_h"], union_time["a_end_m"]);
                  let time_str = start_time_str + "~" + end_time_str;
                  key_str = time_str + "," + lecture_info["a_seq"];
                  let title_str = time_str + " " + lecture_info["a_name"];
                  if (is_filter_group) {
                    title_str = lecture_info["a_subject"] + "(완료)";

                    key_str = time_str + "," + lecture_info["a_subject"];
                    if (filter_group_arr[key_str] == undefined) {
                      filter_group_arr[key_str] = {
                        title: title_str,
                        time_str: time_str,
                        start_time_str: start_time_str,
                        end_time_str: end_time_str,
                        lecture_info: lecture_info,
                        subject: lecture_info["a_subject"],
                        info_arr: [],
                      };
                    }
                    let is_pre_exist = false;
                    for (let j = 0; j < filter_group_arr[key_str]["info_arr"].length; j++) {
                      if (filter_group_arr[key_str]["info_arr"][j]["a_seq"] == info["a_seq"]) {
                        is_pre_exist = true;
                      }
                    }
                    if (is_pre_exist == false) {
                      filter_group_arr[key_str]["info_arr"].push(info);
                    }
                  } else {
                    if (lecture_time_group_arr[key_str] == undefined) {
                      lecture_time_group_arr[key_str] = {
                        title: title_str,
                        time_str: time_str,
                        start_time_str: start_time_str,
                        end_time_str: end_time_str,
                        lecture_info: lecture_info,
                        subject: lecture_info["a_subject"],
                        info_arr: [],
                      };
                    }
                    lecture_time_group_arr[key_str]["info_arr"].push(info);
                  }
                }
              }
            }
          }
        }
      }
    }

    //기타과목얻기
    let etc_subject_arr = [];
    let etc_lecture_arr = [];
    let etc_lecture_seq_arr = [];
    for (let etc_i = 0; etc_i < info_arr_len; etc_i++) {
      let info = info_arr[etc_i];
      let lecture_arr = info["lecture_arr"];
      if (lecture_arr && lecture_arr.length > 0) {
        for (let lec_i = 0; lec_i < lecture_arr.length; lec_i++) {
          let lecture_info = lecture_arr[lec_i];
          if (s_stu_lecture_seq_arr.length > 0) {
            if (strFunc.str_in_array(lecture_info["a_seq"], s_stu_lecture_seq_arr) == -1) {
              continue;
            }
          }
          if (strFunc.str_in_array(lecture_info["a_subject"], etc_subject_arr) == -1) {
            etc_subject_arr.push(lecture_info["a_subject"]);
          }
          if (strFunc.str_in_array(lecture_info["a_seq"], etc_lecture_seq_arr) == -1) {
            etc_lecture_seq_arr.push(lecture_info["a_seq"]);
            etc_lecture_arr.push(lecture_info);
          }
        }
      }
      if (s_stu_lecture_seq_arr.length == 0) {
        if (info.stu_subject_arr && info.stu_subject_arr.length > 0) {
          for (let i = 0; i < info.stu_subject_arr.length; i++) {
            if (strFunc.str_in_array(info.stu_subject_arr[i]["a_name"], etc_subject_arr) == -1) {
              etc_subject_arr.push(info.stu_subject_arr[i]["a_name"]);
            }
          }
        }
      }
    }

    //기타추가
    for (let etc_i = 0; etc_i < info_arr_len; etc_i++) {
      let info = info_arr[etc_i];
      let key_str = "etc";
      if (opt_obj.is_only_now_desk == false) {
        let is_filter_group = GetFilterUser.get_is_filter_user({
          ...opt_obj,
          info: info,
          subject_name: "",
          now_ymdhis: opt_obj.now_ymdhis,
          //is_filter_absent: opt_obj.is_filter_absent,
          is_filter_absent: false,
        });

        if (is_filter_group == false) {
          //등록된 일일보고서에서 찾기
          if (info["daily_report_arr"] && info["daily_report_arr"].length > 0) {
            for (let day_i = 0; day_i < info["daily_report_arr"].length; day_i++) {
              let daily_report_info = info["daily_report_arr"][day_i];
              if (daily_report_info["a_date"] == select_date && !strFunc.is_empty(daily_report_info["a_lecture_seq"])) {
                let time_str = daily_report_info["a_lecture_time"];
                key_str = time_str + "," + daily_report_info["a_lecture_seq"];

                if (lecture_time_group_arr[key_str]) {
                  //없는지확인
                  let tmp_is_exist = false;
                  for (let i = 0; i < lecture_time_group_arr[key_str]["info_arr"].length; i++) {
                    if (lecture_time_group_arr[key_str]["info_arr"][i]["a_seq"] == info["a_seq"]) {
                      tmp_is_exist = true;
                    }
                  }

                  if (tmp_is_exist == false) {
                    lecture_time_group_arr[key_str]["info_arr"].push(info);
                  }
                }
              }
            }
          }
        }
      }

      key_str = "etc";
      if (lecture_time_group_arr[key_str] == undefined) {
        lecture_time_group_arr[key_str] = {
          title: "기타",
          time_str: "00:00~00:00",
          lecture_info: null,
          subject: "",
          info_arr: [],
        };
      }
      let etc_group_arr: any = {};
      for (let s_i = 0; s_i < etc_subject_arr.length; s_i++) {
        let row_subject_name = etc_subject_arr[s_i];

        let is_filter_group = GetFilterUser.get_is_filter_user({
          ...opt_obj,
          info: info,
          subject_name: row_subject_name,
          now_ymdhis: opt_obj.now_ymdhis,
          is_only_now_desk: opt_obj.is_only_now_desk,
          //is_filter_absent: opt_obj.is_filter_absent,
          is_filter_absent: false,
        });
        if (is_filter_group) {
          continue;
        }

        key_str = row_subject_name + "etc";

        let etc_lecture_info = null;
        if (etc_lecture_arr && etc_lecture_arr.length > 0) {
          for (let lec_i = 0; lec_i < etc_lecture_arr.length; lec_i++) {
            let row_lecture_info = etc_lecture_arr[lec_i];
            if (row_lecture_info["a_subject"] == row_subject_name) {
              etc_lecture_info = row_lecture_info;
            }
          }
        }

        if (lecture_time_group_arr[key_str] == undefined) {
          lecture_time_group_arr[key_str] = {
            title: row_subject_name + "etc",
            time_str: "00:00~00:00",
            lecture_info: etc_lecture_info,
            subject: row_subject_name,
            info_arr: [],
          };
        }
        etc_group_arr[key_str] = lecture_time_group_arr[key_str];
      }

      for (let etc_key in etc_group_arr) {
        let etc_group_data = etc_group_arr[etc_key];
        let lecture_arr = info["lecture_arr"];
        let etc_row_pre_exist = false;
        for (var pre_key in lecture_time_group_arr) {
          let pre_group_data = lecture_time_group_arr[pre_key];
          if (pre_group_data["subject"] == etc_group_data["subject"]) {
            for (let i = 0; i < pre_group_data["info_arr"].length; i++) {
              if (pre_group_data["info_arr"][i]["a_seq"] == info["a_seq"]) {
                etc_row_pre_exist = true;
              }
            }
          }
        }

        if (etc_row_pre_exist == false) {
          if (lecture_arr && lecture_arr.length > 0) {
            for (let lec_i = 0; lec_i < lecture_arr.length; lec_i++) {
              let lecture_info = lecture_arr[lec_i];
              if (lecture_info["a_subject"] == etc_group_data["subject"]) {
                let row_is_exist_pre = this_obj.is_exist_user_in_arr({
                  user_arr: lecture_time_group_arr[etc_key]["info_arr"],
                  user_seq: info["a_seq"],
                });
                if (row_is_exist_pre == false) {
                  lecture_time_group_arr[etc_key]["info_arr"].push(info);
                  etc_row_pre_exist = true;
                }
              }
            }
          }
        }

        if (etc_row_pre_exist == false) {
          if (info.stu_subject_arr && info.stu_subject_arr.length > 0) {
            for (let i = 0; i < info.stu_subject_arr.length; i++) {
              if (info.stu_subject_arr[i]["a_name"] == etc_group_data["subject"]) {
                let row_is_exist_pre = this_obj.is_exist_user_in_arr({
                  user_arr: lecture_time_group_arr[etc_key]["info_arr"],
                  user_seq: info["a_seq"],
                });
                if (row_is_exist_pre == false) {
                  lecture_time_group_arr[etc_key]["info_arr"].push(info);
                  etc_row_pre_exist = true;
                }
              }
            }
          }
        }
      }

      //이미있는 유저인지 확인
      let tmp_is_exist_pre = false;
      for (var key in lecture_time_group_arr) {
        let row_is_exist_pre = this_obj.is_exist_user_in_arr({
          user_arr: lecture_time_group_arr[key]["info_arr"],
          user_seq: info["a_seq"],
        });
        if (row_is_exist_pre) {
          tmp_is_exist_pre = row_is_exist_pre;
        }
      }

      if (opt_obj.is_only_now_desk == false) {
        if (tmp_is_exist_pre == false) {
          lecture_time_group_arr["etc"]["info_arr"].push(info);
        }
      }
    }

    //정렬
    for (let key in lecture_time_group_arr) {
      let row_subject_name = "";
      if (lecture_time_group_arr[key]["lecture_info"]) {
        row_subject_name = lecture_time_group_arr[key]["lecture_info"]["a_subject"];
      } else if (lecture_time_group_arr[key]["subject"]) {
        row_subject_name = lecture_time_group_arr[key]["subject"];
      }
      if (opt_obj.is_order_by_desk_use) {
        lecture_time_group_arr[key]["info_arr"] = DeskUseDataFunc.get_ordered_stu_arr_by_desku_arr({
          info_arr: lecture_time_group_arr[key]["info_arr"],
          subject_name: row_subject_name,
          now_ymdhis: opt_obj.now_ymdhis,
        });
      }

      if (opt_obj.is_order_by_attend) {
        lecture_time_group_arr[key]["info_arr"] = AttendStateFunc.get_user_arr_by_attend_order({
          user_arr: lecture_time_group_arr[key]["info_arr"],
          select_date: opt_obj.select_date,
        });
      }

      if (opt_obj.is_order_by_core_date) {
        lecture_time_group_arr[key]["info_arr"] = GetOrderUser.get_order_user_by_core_date({
          info_arr: lecture_time_group_arr[key]["info_arr"],
          subject_name: row_subject_name,
          select_date: opt_obj.select_date,
        });
      }
    }


    for (let key in lecture_time_group_arr) {
      let group_info = lecture_time_group_arr[key];
      group_arr.push({
        "title": group_info["title"],
        "time_str": group_info["time_str"],
        "start_time_str": group_info["start_time_str"],
        "end_time_str": group_info["end_time_str"],
        "info_arr": group_info["info_arr"],
        "lecture_info": group_info["lecture_info"],
        "subject": group_info["subject"],
      });
    }

    return group_arr;
  };

  static is_exist_user_in_arr(inData: any) {
    let opt_obj = {
      user_arr: [],
      user_seq: "",
      ...inData
    };
    let is_exist = false;
    let user_arr_len = opt_obj.user_arr.length;
    for (let i = 0; i < user_arr_len; i++) {
      let info = opt_obj.user_arr[i];
      if (info.a_seq == opt_obj.user_seq) {
        return true;
      }
    }
    return is_exist;
  }
}
export default UserGroupDataFunc;